import React from 'react';

const NoInterestModal = ({ onClose }) => {
  return (
    <div className="modal-overlay-nointerest">
      <div className="modal-nointerest-box">
        <button
          className="modal-close-button"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <p className="nointerest-error-text">
          Please add at least one interest before starting a module.
        </p>
      </div>
    </div>
  );
};

export default NoInterestModal;
